import React, { useState, useEffect, useCallback, useRef } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import toastr from "toastr";

import FormA from "../FormA/FormA.component";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { employeeFormAFields, initialEmployeeFormA } from "./Constant";
import {
  getEmployeeByID,
  updateEmployeeFormA,
} from "app/_services/UserManagement/EmployeeService";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";

function EditEmployeeFormA() {
  const [form, setForm] = useState(() => initialEmployeeFormA);
  const processingRef = useRef(false);

  const { id } = useParams();

  const onChange = useCallback(
    ({ target: { name, value } }) =>
      setForm((prevForm) => ({ ...prevForm, [name]: value })),
    []
  );

  const onSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      if (processingRef.current) return;

      const formData = new FormData();

      Object.keys(employeeFormAFields).forEach((key) =>
        employeeFormAFields[key].fields.forEach((field) => {
          if (field.readOnly) return;

          if (field.inputType !== "section")
            formData.append(field.name, form[field.name]);
          else for (const { name } of field.fields) formData.append(name, form[name]);
        })
      );

      const response = await updateEmployeeFormA(id, formData);

      setTimeout(() => {
        processingRef.current = false;
      }, 1000);

      if (!response?.status) {
        return toastr.error("Could not update!", "Error.");
      }

      toastr.success("Updated successfully.", "Success.");
    },
    [id, form]
  );

  useEffect(() => {
    if (!id) return;

    getEmployeeByID(id).then((response) => {
      if (!response?.data) return;
      const employeeData = response.data.employees || {};

      setForm((prevForm) => ({
        ...prevForm,
        ...response.data.employees,
        startDateAtMines: employeeData.startDateAtMines?.slice(0, 10) || "",
        dateOfJoining: employeeData.dateOfJoining?.slice(0, 10) || "",
        dateOfSeparation: employeeData.dateOfSeparation?.slice(0, 10) || "",
        siteType: employeeData.ehsSite?.siteType || "",
        mineName: employeeData.ehsSite?.name || "",
        mineCode: employeeData.ehsSite?.mineCode || "",
        fullName: `${employeeData.firstName || ""} ${employeeData.middleName || ""} ${
          employeeData.lastName || ""
        }`,
        ...(employeeData.employeeFormA || {}),
        profilePicture: employeeData.employeeFormA?.profilePicture
          ? `${URL_CONFIG.IMG_URL}${employeeData.employeeFormA?.profilePicture}`
          : "",
      }));
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          { name: "Form A Management", path: "#" },
          { name: "Edit" },
        ]}
      />

      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title mb-0">
            <h3 class="text-capitalize mb-1">Edit Employee Form A</h3>
          </Card.Title>
          <FormA
            fieldsObj={employeeFormAFields}
            form={form}
            id={id}
            onChange={onChange}
            onSubmit={onSubmit}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default EditEmployeeFormA;
